import { drop, take } from '@execonline-inc/collections';
import format from 'date-fns/format';
import { Maybe, just } from 'maybeasy';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { DateField } from '../../Types';

export interface Props {
  field: DateField;
  disabled: boolean;
}

export const nextHour = (): Date => {
  const date = new Date();
  date.setHours(date.getHours() + 1);
  date.setMinutes(0);
  return date;
};

const toDate = (time: string): Date => {
  let now = new Date();
  now.setHours(Number(take(2, time.split('')).join('')));
  now.setMinutes(Number(drop(3, time.split('')).join('')));
  now.setSeconds(0);
  return now;
};

const dateToLocalTime = (time: Date) => format(time, 'HH:mm');

const getNewTime = (value: Maybe<Date>, e: React.ChangeEvent<HTMLInputElement>): Date => {
  const now = new Date();
  return value
    .map(
      (value) =>
        new Date(
          value.getFullYear(),
          value.getMonth(),
          value.getDate(),
          toDate(e.target.value).getHours(),
          toDate(e.target.value).getMinutes(),
        ),
    )
    .getOrElse(
      () =>
        new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          toDate(e.target.value).getHours(),
          toDate(e.target.value).getMinutes(),
        ),
    );
};

const onChange = (field: DateField) =>
  action(
    (e: React.ChangeEvent<HTMLInputElement>) => (field.value = just(getNewTime(field.value, e))),
  );

const Time: React.FC<Props> = ({ field, disabled }) => (
  <div className="flex flex-col mr-2">
    <label htmlFor="send-time" className="font-semibold text-sm">
      <T kind="Time" />
    </label>
    <input
      type="time"
      id="send-time"
      value={dateToLocalTime(field.value.getOrElseValue(nextHour()))}
      onChange={onChange(field)}
      name="send-time"
      className="rounded border-gray-300 w-36 disabled:bg-gray-50 disabled:text-gray-400"
      disabled={disabled}
    />
  </div>
);

export default observer(Time);
